import State from '@/models/State'
import Vue from "vue"

export default class RestState {
  public list() {
    return Vue.$axios.get<State[]>("state")
  }
}
